import { render } from "./MainButtons.vue?vue&type=template&id=345a7c5b"
import script from "./MainButtons.vue?vue&type=script&lang=js"
export * from "./MainButtons.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\game\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__